import dynamic from "next/dynamic";
const FadeInAssetComponent = dynamic(()=>import("./fade-in-asset-component"));
import FadeInAssetConfig from "./fade-in-asset-config";
import FadeInAssetAdvancedConfig from "./fade-in-asset-advanced-config";
export default {
    FadeInAssetComponent,
    FadeInAssetConfig,
    FadeInAssetAdvancedConfig
};
